module.exports = __webpack_public_path__ + "media/logo/logo_finc-04e4c5b3.png";